import { render, staticRenderFns } from "./TrailerPlayer.vue?vue&type=template&id=66631869&scoped=true"
import script from "./TrailerPlayer.vue?vue&type=script&lang=js"
export * from "./TrailerPlayer.vue?vue&type=script&lang=js"
import style0 from "./TrailerPlayer.vue?vue&type=style&index=0&id=66631869&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66631869",
  null
  
)

export default component.exports